export const invitationsApi = (client) => ({
    list: () => client.get('/api/v1/invitations').then((r) => r.data),
    get: (id) => client.get(`/api/v1/invitations/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/invitations', body).then((r) => r.data),
    resend: (id) => client.post(`/api/v1/invitations/${id}/resend`).then((r) => r.data),
    revoke: (id) => client.delete(`/api/v1/invitations/${id}`).then((r) => r.data),
    // Public (no auth)
    validate: (token, org_slug) => client
        .get(`/api/v1/invitations/validate/${encodeURIComponent(token)}`, { params: { org_slug } })
        .then((r) => r.data),
    accept: (body) => client
        .post('/api/v1/invitations/accept', body)
        .then((r) => r.data),
});
//# sourceMappingURL=invitations.js.map